import React, { FC, RefObject } from 'react'
import { Direction, REQUEST_CONFIGS_KEYS } from '@services/constants'
import TextInput from '../inputs/text.inputs'
import RadioInput from '../inputs/radio.input'
import {
	classes,
	isRenovationSectionA,
	isRenovationSectionB
} from './__index.utils'
import { CheckboxList, RadioList, SelectList } from '@utils/request'
import * as utilsList from './__index.utils'
import Notification from '@components/ui/notification'
import CheckboxInput from '../inputs/checkbox.input'
import SelectInput from '../inputs/select.inputs'
import MeasurementInput from '../inputs/measurement.input'
import { joinClasses } from '@utils/styles'
import TextAreaInput from '../inputs/textarea.inputs'

const Step4_1RenovationOrDevelopment = ({
	pageAssets,
	pageUtils,
	formInputs,
	errors,
	updateInput,
	onFixError,
	isSummaryStep = false,
	// *******
	updateCheckBoxInput
}) => {
	const {
		whatToDo,

		// ***********************
		mainUseOfExistingBuilding,
		doYouWantToChangeCurrentUse,
		projectedUse,
		// ***********************
		typesOfWorkRenovation,
		workDescriptionRenovationInterior,
		areaOfPremisesRenovationInterior,
		areaOfPremisesUnitRenovationInterior,
		currentNumberOfUnitsRenovationInterior,
		numberOfUnitsAddedRenovationInterior,
		workDescriptionRenovationExterior,
		existingMaterialsRenovationExterior,
		projectedMaterialsRenovationExterior,
		isTerraceAdditionOrModificationRenovation,
		isParkingAreaModificationRenovation,
		isFloorAreaModificationRenovation
	} = formInputs

	const radioListTypesOfWorkRenovation: CheckboxList[] =
		utilsList.radioListTypesOfWorkRenovation(pageAssets)

	const radioListMeasurementUnit: RadioList[] =
		utilsList.radioListMeasurementUnit(pageAssets)

	const radioListMeasurement2Unit: RadioList[] =
		utilsList.radioListMeasurement2Unit(pageAssets)

	const radioListYesNo: RadioList[] = utilsList.radioListYesNo(pageAssets)

	return (
		<>
			{!isSummaryStep && (
				<h4 className={pageUtils.classes.h4}>
					{pageAssets?.request_form_renovations_informations}
				</h4>
			)}

			<CheckboxInput
				name={typesOfWorkRenovation.name}
				label={typesOfWorkRenovation.label}
				description={typesOfWorkRenovation.description}
				value={`${typesOfWorkRenovation.value}`}
				list={radioListTypesOfWorkRenovation}
				onChange={(value) => updateCheckBoxInput(typesOfWorkRenovation, value)}
				required={typesOfWorkRenovation.required}
				hasError={errors.includes(typesOfWorkRenovation.name)}
				ref={typesOfWorkRenovation.ref as RefObject<HTMLInputElement>}
				errors={errors}
				shouldNotDivide
				hasBackgroundWrapper
				onFixError={onFixError}
				newCheckValue
				isSummaryStep={isSummaryStep}
			/>

			{/* Section A */}
			{isRenovationSectionA(typesOfWorkRenovation.value) && (
				<>
					<h5 className={pageUtils.classes.h5}>
						{
							pageAssets?.request_form_commerialPermit_typesOfWorkRenovation_interior
						}
					</h5>

					<TextAreaInput
						id={workDescriptionRenovationInterior.name}
						label={workDescriptionRenovationInterior.label}
						value={workDescriptionRenovationInterior.value}
						onChange={(value) =>
							updateInput(workDescriptionRenovationInterior.name, value)
						}
						hasError={errors!.includes(workDescriptionRenovationInterior.name)}
						required={workDescriptionRenovationInterior.required}
						ref={
							workDescriptionRenovationInterior.ref as RefObject<HTMLTextAreaElement>
						}
						maxCharacters={100}
						hasDescriptionLabel={workDescriptionRenovationInterior.description}
						displayDescriptionTop
						descriptionAlignment="left"
						rows={4}
						isSummaryStep={isSummaryStep}
					/>

					<MeasurementInput
						measurementInput={areaOfPremisesRenovationInterior}
						unitInput={areaOfPremisesUnitRenovationInterior}
						listMeasurementUnit={radioListMeasurement2Unit}
						maxCharacters={12}
						isSummaryStep={isSummaryStep}
						errors={errors}
						onFixError={onFixError}
						updateInput={updateInput}
						hasError={errors?.includes(areaOfPremisesRenovationInterior.name)}
						reducedMargin
					/>

					{/* //condition d'affichage de ces champs */}
					{(mainUseOfExistingBuilding.value?.toString() ==
						REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingCommercial.mixed &&
						doYouWantToChangeCurrentUse.value?.toString() == 'false') ||
					projectedUse.value?.toString() ===
						REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingCommercial.mixed ? (
						<>
							<TextInput
								id={currentNumberOfUnitsRenovationInterior.name}
								label={currentNumberOfUnitsRenovationInterior.label}
								value={currentNumberOfUnitsRenovationInterior.value}
								onChange={(value) =>
									updateInput(
										currentNumberOfUnitsRenovationInterior.name,
										value
									)
								}
								hasError={errors!.includes(
									currentNumberOfUnitsRenovationInterior.name
								)}
								required={currentNumberOfUnitsRenovationInterior.required}
								ref={
									currentNumberOfUnitsRenovationInterior.ref as RefObject<HTMLInputElement>
								}
								maxCharacters={6}
								type="text"
								onKeyPress={pageUtils.onKeyPressIntegerInput}
								min="0"
								isSummaryStep={isSummaryStep}
							/>

							<TextInput
								id={numberOfUnitsAddedRenovationInterior.name}
								label={numberOfUnitsAddedRenovationInterior.label}
								value={numberOfUnitsAddedRenovationInterior.value}
								onChange={(value) =>
									updateInput(numberOfUnitsAddedRenovationInterior.name, value)
								}
								hasError={errors!.includes(
									numberOfUnitsAddedRenovationInterior.name
								)}
								required={numberOfUnitsAddedRenovationInterior.required}
								ref={
									numberOfUnitsAddedRenovationInterior.ref as RefObject<HTMLInputElement>
								}
								maxCharacters={6}
								type="text"
								onKeyPress={pageUtils.onKeyPressIntegerInput}
								min="0"
								isSummaryStep={isSummaryStep}
							/>
						</>
					) : (
						''
					)}
				</>
			)}

			{/* Section B  */}
			{isRenovationSectionB(typesOfWorkRenovation.value) && (
				<>
					<h5 className={pageUtils.classes.h5}>
						{
							pageAssets?.request_form_commerialPermit_typesOfWorkRenovation_exterior
						}
					</h5>

					<TextAreaInput
						id={workDescriptionRenovationExterior.name}
						label={workDescriptionRenovationExterior.label}
						value={workDescriptionRenovationExterior.value}
						onChange={(value) =>
							updateInput(workDescriptionRenovationExterior.name, value)
						}
						hasError={errors!.includes(workDescriptionRenovationExterior.name)}
						required={workDescriptionRenovationExterior.required}
						ref={
							workDescriptionRenovationExterior.ref as RefObject<HTMLTextAreaElement>
						}
						maxCharacters={100}
						hasDescriptionLabel={workDescriptionRenovationExterior.description}
						displayDescriptionTop
						descriptionAlignment="left"
						rows={4}
						isSummaryStep={isSummaryStep}
					/>

					<TextInput
						id={existingMaterialsRenovationExterior.name}
						label={existingMaterialsRenovationExterior.label}
						value={existingMaterialsRenovationExterior.value}
						onChange={(value) =>
							updateInput(existingMaterialsRenovationExterior.name, value)
						}
						hasError={errors.includes(existingMaterialsRenovationExterior.name)}
						required={existingMaterialsRenovationExterior.required}
						ref={
							existingMaterialsRenovationExterior.ref as RefObject<HTMLInputElement>
						}
						maxCharacters={50}
						isSummaryStep={isSummaryStep}
					/>

					<TextInput
						id={projectedMaterialsRenovationExterior.name}
						label={projectedMaterialsRenovationExterior.label}
						value={projectedMaterialsRenovationExterior.value}
						onChange={(value) =>
							updateInput(projectedMaterialsRenovationExterior.name, value)
						}
						hasError={errors.includes(
							projectedMaterialsRenovationExterior.name
						)}
						required={projectedMaterialsRenovationExterior.required}
						ref={
							projectedMaterialsRenovationExterior.ref as RefObject<HTMLInputElement>
						}
						maxCharacters={50}
						isSummaryStep={isSummaryStep}
					/>
				</>
			)}

			{/* // ***************************************
				// Section C -Informations supplémentaires
			// *************************************** */}
			{(isRenovationSectionA(typesOfWorkRenovation.value) ||
				isRenovationSectionB(typesOfWorkRenovation.value)) && (
				<>
					{(!isSummaryStep ||
						(isSummaryStep &&
							(isTerraceAdditionOrModificationRenovation.value != '' ||
								isParkingAreaModificationRenovation.value != '' ||
								isFloorAreaModificationRenovation.value != ''))) && (
						<h5 className={pageUtils.classes.h5}>
							{pageAssets?.request_form_additional_info}
						</h5>
					)}
				</>
			)}

			{isRenovationSectionB(typesOfWorkRenovation.value) && (
				<>
					{/* Question 19 */}
					<RadioInput
						name={isTerraceAdditionOrModificationRenovation.name}
						label={isTerraceAdditionOrModificationRenovation.label}
						value={isTerraceAdditionOrModificationRenovation.value}
						list={radioListYesNo}
						direction={Direction.vertical}
						hasError={errors!.includes(
							isTerraceAdditionOrModificationRenovation.name
						)}
						onChange={(value) =>
							updateInput(isTerraceAdditionOrModificationRenovation.name, value)
						}
						ref={
							isTerraceAdditionOrModificationRenovation.ref as RefObject<HTMLInputElement>
						}
						required={isTerraceAdditionOrModificationRenovation.required}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
						reducedMargin={true}
					/>

					{!isSummaryStep &&
						isTerraceAdditionOrModificationRenovation.value === 'true' && (
							<Notification
								type="info"
								text={
									pageAssets.request_form_commercialPermit_isTerraceAdditionOrModification_notification
								}
								hasHtml
							/>
						)}

					{/* Question 20 */}
					<RadioInput
						name={isParkingAreaModificationRenovation.name}
						label={isParkingAreaModificationRenovation.label}
						value={isParkingAreaModificationRenovation.value}
						list={radioListYesNo}
						direction={Direction.vertical}
						hasError={errors!.includes(
							isParkingAreaModificationRenovation.name
						)}
						onChange={(value) =>
							updateInput(isParkingAreaModificationRenovation.name, value)
						}
						ref={
							isParkingAreaModificationRenovation.ref as RefObject<HTMLInputElement>
						}
						required={isParkingAreaModificationRenovation.required}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
						reducedMargin={true}
					/>

					{!isSummaryStep &&
						isParkingAreaModificationRenovation.value === 'true' && (
							<Notification
								type="info"
								text={
									pageAssets.request_form_commercialPermit_isParkingAreaModification_notification
								}
								hasHtml
							/>
						)}
				</>
			)}

			{(isRenovationSectionA(typesOfWorkRenovation.value) ||
				isRenovationSectionB(typesOfWorkRenovation.value)) && (
				<>
					<RadioInput
						name={isFloorAreaModificationRenovation.name}
						label={isFloorAreaModificationRenovation.label}
						value={isFloorAreaModificationRenovation.value}
						list={radioListYesNo}
						direction={Direction.vertical}
						hasError={errors!.includes(isFloorAreaModificationRenovation.name)}
						onChange={(value) =>
							updateInput(isFloorAreaModificationRenovation.name, value)
						}
						ref={
							isFloorAreaModificationRenovation.ref as RefObject<HTMLInputElement>
						}
						required={isFloorAreaModificationRenovation.required}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
						reducedMargin={true}
					/>

					{!isSummaryStep &&
						isFloorAreaModificationRenovation.value === 'true' && (
							<Notification
								type="info"
								text={
									pageAssets.request_form_commercialPermit_isFloorAreaModification_notification
								}
								hasHtml
							/>
						)}
				</>
			)}
		</>
	)
}

export default Step4_1RenovationOrDevelopment
